<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.getLogo()
    this.getName()
  },
  methods: {
    getName() {

      this.$http.post('/api/index/customer_service').then(res => {
        document.title = res.data.platform_name

      })
    },
    getLogo() {
      this.$http.post('/api/index/logo').then(res => {
        console.log(res)
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.rel = 'shortcut icon';
        link.href = res.data.logo
        document.getElementsByTagName('head')[0].appendChild(link);
        // document.title = res.data.platform_name
      })

    },
  }
}
</script>
<style lang="scss">
@import 'animate.css';
// @import '@/utils/index.css';
@import '@/utils/custom.scss';

html body {
  margin: 0;
  padding: 0;
  color: #333;

}

/* 隐藏滚动条的样式 */
::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera*/
}

.rubberBand {
  animation: rubberBand;
  animation-duration: 0.9s;
}

.heartBeat {
  animation: heartBeat;
  animation-duration: 0.9s;
}

.fadeInDown {
  animation: fadeInDown;
  animation-duration: 0.9s;
}

.fadeInUp {
  animation: fadeInUp;
  animation-duration: 0.9s;
}

.fadeInLeft {
  animation: fadeInLeft;
  animation-duration: 0.9s;
}

.backInTopLeft {
  animation: fadeInTopLeft;
  animation-duration: 0.9s;
}

.backInTopRight {
  animation: fadeInTopRight;
  animation-duration: 0.9s;
}

.backInBottomRight {
  animation: fadeInBottomRight;
  animation-duration: 0.9s;
}

.backInBottomLeft {

  animation: fadeInBottomLeft;
  animation-duration: 0.9s;
}

.flipInX {
  animation: flipInX;
  animation-duration: 0.9s;
}

.flip {
  animation: flip;
  animation-duration: 0.9s;
}

.backInDown {
  animation: backInDown;
  animation-duration: 0.9s;
}

.backInUp {
  animation: backInUp;
  animation-duration: 0.9s;
}

.flipInY {
  animation: flipInY;
  animation-duration: 0.9s;
}

.slideInUp {
  animation: slideInUp;
  animation-duration: 0.9s;
}

.hover-scale {
  &:hover {
    transform: scale(1.02);
    transition: all .5s;
  }
}
</style>
